import { render, staticRenderFns } from "./ImportsNewProductsList.vue?vue&type=template&id=8ac609ec&"
import script from "./ImportsNewProductsList.vue?vue&type=script&lang=js&"
export * from "./ImportsNewProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports